<template>
    <div>
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>Demandes complétées ({{ requestSum }})</h2>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <old-request-bloc v-if="oldCmajRequests.length"
                                  title="Demandes de mises à jours complétées"
                                  :requests="oldCmajRequests">
                    </old-request-bloc>

                    <old-request-bloc v-if="oldCadhRequests.length"
                                  title="Demandes de partenariat complétées"
                                  :requests="oldCadhRequests">
                    </old-request-bloc>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import OldRequestBloc from "./OldRequestBloc"
export default {
    name: "ProOldRequest",
    components: {OldRequestBloc},
    props: ['oldCadhRequests', 'oldCmajRequests'],
    computed: {
        requestSum() {
            return this.oldCmajRequests.length + this.oldCadhRequests.length
        }
    }
}
</script>